import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    name: '',
    propertyCount: 0,
    userCount: 0,
    pendingUserCount: 0,
    isLoading: true,
    error: null,
});

const company = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.USER_MANAGEMENT_GET_COMPANY_LOADING:
            return initState();
        case DispatchConstants.USER_MANAGEMENT_GET_COMPANY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...payload.company,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_COMPANY_FAIL:
            return {
                ...state,
                isLoading: false,
                error: payload.error,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_COMPANY_NAME:
            return {
                ...state,
                name: payload.companyName,
            };
        default:
            return state;
    }
};

export default company;
